import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  icon?: string;
  moreLabel?: string;
  moreLink?: string;
}

export default function SectionHeading({
  title,
  icon,
  moreLabel,
  moreLink,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 border-b border-background-200 pb-3">
      <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
        <span className="flex h-5 w-1.5 rounded-full bg-accent-500"></span>
        {icon && <i className={`${icon} text-primary-600`}></i>}
        {title}
      </h2>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}